import React from 'react';


import './SocialPreview.scss';

// Platform configurations
const PLATFORM_CONFIG = {
  linkedin: {
    actionButtons: [
      { icon: '👍', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '🔄', label: 'Share' },
      { icon: '📤', label: 'Send' }
    ],
    color: '#0077b5',
    showDescription: true,
    mediaLayout: 'grid',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  twitter: {
    actionButtons: [
      { icon: '❤️', label: 'Like' },
      { icon: '💬', label: 'Reply' },
      { icon: '🔄', label: 'Repost' },
      { icon: '📊', label: 'Views' }
    ],
    color: '#1DA1F2',
    showDescription: false,
    mediaLayout: 'stack'
  },
  facebook: {
    actionButtons: [
      { icon: '👍', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '🔄', label: 'Share' }
    ],
    color: '#4267B2',
    showDescription: true,
    mediaLayout: 'grid',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  pinterest: {
    actionButtons: [
      { icon: '📌', label: 'Save' },
      { icon: '🔄', label: 'Share' }
    ],
    color: '#E60023',
    showDescription: true,
    mediaLayout: 'pinterest',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  youtube: {
    actionButtons: [
      { icon: '👍', label: 'Like' },
      { icon: '👎', label: 'Dislike' },
      { icon: '🔄', label: 'Share' },
      { icon: '💾', label: 'Save' }
    ],
    color: '#FF0000',
    showDescription: true,
    mediaLayout: 'video',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  instagram: {
    actionButtons: [
      { icon: '❤️', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '🔄', label: 'Share' },
      { icon: '📤', label: 'Send' }
    ],
    color: '#E4405F',
    showDescription: false,
    mediaLayout: 'square',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  snapchat: {
    actionButtons: [
      { icon: '👻', label: 'Snap' },
      { icon: '💬', label: 'Chat' },
      { icon: '🔄', label: 'Share' }
    ],
    color: '#FFFC00',
    showDescription: false,
    mediaLayout: 'vertical',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  google: {
    actionButtons: [
      { icon: '👍', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '🔄', label: 'Share' }
    ],
    color: '#4285F4',
    showDescription: true,
    mediaLayout: 'grid',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  },
  tiktok: {
    actionButtons: [
      { icon: '❤️', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '🔄', label: 'Share' }
    ],
    color: '#000000',
    showDescription: false,
    mediaLayout: 'vertical',
    analytics: {
      showImpressions: true,
      showEngagement: true,
      detailedStats: true
    }
  }
};

export const SocialPreview = ({ previewData, onRemoveAttachment }) => {
  const {
    platform,
    author,
    content,
    engagement,
    timestamp,
    username,
    isVerified
  } = previewData;

  const config = PLATFORM_CONFIG[platform];
  if (!config) return <div>Unsupported platform</div>;

  const formatEngagementCount = (count) => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count;
  };



  return (
    <div className={`social-preview social-preview--${platform}`}
         style={{ '--platform-color': config.color }}>
      <div className="social-preview__container">
        <div className="social-preview__card">
          {/* Header */}
          <div className="post-header">
            <div className="post-header__avatar">
              <img src={author.image} alt={author.name} />
            </div>
            
            <div className="post-header__content">
              <div className="post-header__title">
                <span className="post-header__name">{author.name}</span>
                {isVerified && (
                  <span className="verified-badge">
                    <i className={`fab fa-${platform}`}></i>
                  </span>
                )}
                {username && (
                  <span className="post-header__handle">@{username}</span>
                )}
              </div>
              
              {config.showDescription && author.description && (
                <div className="post-header__description">
                  {author.description}
                </div>
              )}
              
              <div className="post-header__meta">
                <span className="timestamp">{timestamp}</span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="post-content">
            <div className="post-content__text">
              {content.mainText}
            </div>
            
            {content.hashtags?.length > 0 && (
              <div className="post-content__hashtags">
                {content.hashtags.map((tag, index) => (
                  <span key={index} className="hashtag">#{tag} </span>
                ))}
              </div>
            )}

            {/* Media */}
            {content.media?.length > 0 && (
              <div className={`media-content media-content--${config.mediaLayout}`}>
                {content.media.map((item, index) => (
                  <div key={index} className={`media-content__${item.type}`}>
                    {item.type === 'video' ? (
                      <div className="media-content__video-container">
                        <video src={item.url} controls={platform !== 'tiktok'} />
                        <button
                        type="button"
                        className="remove-button"
                        onClick={(e) => {e.stopPropagation(); onRemoveAttachment(item.alt)}}
                      >
                        ×
                      </button>
                      </div>
                    ) : (
                      <div className="media-content__image-container">
                        <img
                          src={item.url}
                          alt={item.alt}
                          className="media-content__image"
                          onError={(e) => {
                            // Failed posts can have stale URLs (image
                            // generation produced a file that's since been
                            // GC'd, or R2 key 404s). Swap to an inline
                            // SVG placeholder so the preview frame still
                            // renders something usable instead of a
                            // browser-default broken icon.
                            const img = e.currentTarget;
                            if (img.dataset.fallback === '1') return;
                            img.dataset.fallback = '1';
                            img.src =
                              'data:image/svg+xml;utf8,' +
                              encodeURIComponent(
                                "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 120'>" +
                                "<rect width='200' height='120' fill='#f1f5f9'/>" +
                                "<text x='100' y='65' text-anchor='middle' font-family='sans-serif' font-size='13' fill='#94a3b8'>image unavailable</text>" +
                                "</svg>"
                              );
                          }}
                        />
                        <button
                        type="button"
                        className="remove-button"
                        onClick={(e) => {e.stopPropagation(); onRemoveAttachment(item.alt);}}
                      >
                        ×
                      </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Engagement */}
          <div className="engagement">
            <div className="engagement__stats">
              {engagement.likes > 0 && (
                <span>{formatEngagementCount(engagement.likes)} Likes</span>
              )}
              {engagement.comments?.length > 0 && (
                <span>{formatEngagementCount(engagement.comments.length)} Comments</span>
              )}
              {engagement.shares > 0 && (
                <span>{formatEngagementCount(engagement.shares)} Shares</span>
              )}
              {engagement.views > 0 && platform === 'youtube' && (
                <span>{formatEngagementCount(engagement.views)} Views</span>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="action-buttons">
            {config.actionButtons.map((button, index) => (
              <button 
                key={index} 
                className={`action-buttons__button action-buttons__button--${platform}`}
              >
                <span className="action-buttons__icon">{button.icon}</span>
                <span className="action-buttons__label">{button.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialPreview;